var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoices-table"},[_c('AgGrid',{ref:"agGrid",attrs:{"options":_vm.gridOptions,"row-data":_vm.clonedInvoices,"context":_vm.context},on:{"cell-value-changed":_vm.cellValueChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }